// client/src/constants/tournament.js
export const REQUIRED_LEVEL_KEY = 'level';
export const REQUIRED_TIME_KEY = 'time';
